import * as React from "react";

import {faceIconColor} from "@repo/auth-shared";

export const MicrosoftIcon = ({
    disabled = false,
    ariaHidden,
}: {
    disabled?: boolean;
    ariaHidden?: boolean;
}): React.ReactElement<React.ComponentProps<"svg">> => {
    const fadeFn = faceIconColor(disabled);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            aria-hidden={ariaHidden}
            viewBox="0 0 23 23"
        >
            <path fill={fadeFn("#f3f3f3")} d="M0 0h23v23H0z" />
            <path fill={fadeFn("#f35325")} d="M1 1h10v10H1z" />
            <path fill={fadeFn("#81bc06")} d="M12 1h10v10H12z" />
            <path fill={fadeFn("#05a6f0")} d="M1 12h10v10H1z" />
            <path fill={fadeFn("#ffba08")} d="M12 12h10v10H12z" />
        </svg>
    );
};
